// extracted by mini-css-extract-plugin
export var addressFields = "_gg-0";
export var animationContainer = "_gg-1";
export var footer = "_gg-2";
export var lineItems = "_gg-3";
export var modalContent = "_gg-4";
export var orderName = "_gg-5";
export var strong = "_gg-6";
export var warning = "_gg-7";